import { createSlice } from '@reduxjs/toolkit'

export const scrollButtonSlice = createSlice({
	name: 'scrollButton',
	initialState: {
		visibility: 'hide',
	},
	reducers: {
		showScrollButton: (state, { payload }) => {
			state.visibility = 'show'
		},
		hideScrollButton: (state, { payload }) => {
			state.visibility = 'hide'
		},
	},
})

export const { showScrollButton, hideScrollButton } = scrollButtonSlice.actions

export const { reducer } = scrollButtonSlice
